<template>
    <div class="g-flex-center-center">
        <div class="mine-cash g-flex-center-center">
            <div class="divide-icon-red"></div>
            <p class="mine-cash-text">可提现</p>
            <p class="mine-cash-num q-number">{{ store.mainData.available_balance || 0 }}</p>
            <p class="mine-cash-unit">元</p>
            <div class="mine-cash-btn" v-if="![1, 2].includes(storeCommon.userInfo.user_type)">登录后提现</div>
            <div class="mine-cash-btn" v-else-if="!store.mainData.can_withdraw">满0.1元即可提现</div>
            <div class="mine-cash-btn" @click="jumpToBind" v-else-if="!store.mainData.is_bind_weixin">去绑定</div>
            <div class="mine-cash-btn" v-else @click="onWithdrawAll">全部提现</div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { schemaSingle } from '@q-front-npm/jsbridge';
import { useStore } from '@divide/store';
import { useStoreCommon } from '@qm-activity/common/store/common';
const store = useStore();
const storeCommon = useStoreCommon();
const emit = defineEmits(['withdraw']);
const jumpToBind = () => {
    schemaSingle.runSchema('settings_bindwechat', {}, (status: any) => {
        if (+status === 1) {
            console.log('已绑定微信');
            store.mainData.is_bind_weixin = true;
        }
    });
};

const onWithdrawAll = () => {
    emit('withdraw');
};
</script>
<style lang="scss" scoped>
.mine-cash {
    position: relative;
    margin-top: 20px;
    padding-left: 16px;
    height: 64px;
    border-radius: 20px;
    overflow: hidden;
    border: 0.5px solid rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.1);

    &-text {
        margin-left: 6px;
        font-size: 24px;
        color: #ffffff;
        line-height: 34px;
    }
    &-num {
        margin-left: 12px;
        font-weight: bold;
        font-size: 36px;
        color: #ffffff;
        line-height: 38px;
    }
    &-unit {
        margin-left: 4px;
        margin-top: 8px;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        line-height: 26px;
    }

    &-btn {
        margin-left: 32px;
        margin-top: -0.5px;
        margin-bottom: -0.5px;
        margin-right: -0.5px;
        height: 64px;
        border: 0.5px solid rgba(255, 255, 255, 0.3);
        border-radius: 20px;
        font-weight: bold;
        font-size: 26px;
        color: #ffffff;
        line-height: 64px;
        text-align: center;
        padding: 0 18px;
        background: rgba(255, 255, 255, 0.15);
    }
}
</style>
